var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resource-niche" },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入标题", clearable: "" },
            model: {
              value: _vm.titleName,
              callback: function ($$v) {
                _vm.titleName = $$v
              },
              expression: "titleName",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadConfig } },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
            [_vm._v("添加资源位")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.nicheList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标题", "min-width": "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "title-with-image" }, [
                      _c("span", { staticClass: "title-text" }, [
                        _vm._v(_vm._s(scope.row.extra.title)),
                      ]),
                      _vm._v(" "),
                      scope.row.extra.imageUrl
                        ? _c("div", { staticClass: "title-image" }, [
                            _c("img", {
                              staticClass: "title-preview-img",
                              attrs: {
                                src: _vm.getImageUrl(scope.row.extra.imageUrl),
                                alt: "资源位图片",
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "推荐类型", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getTypeTagType(scope.row.recommendType),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getTypeText(scope.row.recommendType)) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "推荐内容", "min-width": "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getRecommendContent(scope.row)) +
                        "\n             "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否永久有效", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(scope.row.extra.isPermanent ? "是" : "否") +
                        "\n            "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "开始-结束时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.extra.isPermanent
                      ? _c("div", { staticClass: "time-range" }, [
                          _c("div", [
                            _vm._v(_vm._s(scope.row.extra.startTime)),
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(scope.row.extra.endTime))]),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "排序", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.extra.sort))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否显示", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisible(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "200", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(scope.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "1200px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              { staticClass: "left-panel" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.rules,
                      "label-width": "110px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "title" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入标题" },
                          model: {
                            value: _vm.formData.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "title", $$v)
                            },
                            expression: "formData.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "推荐类型", prop: "recommendType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.changeRecommendInfo },
                            model: {
                              value: _vm.formData.recommendType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "recommendType", $$v)
                              },
                              expression: "formData.recommendType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("NOTHING"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("领券弹窗"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 3 } }, [
                              _vm._v("系统弹窗"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 5 } }, [
                              _vm._v("调查问卷"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 6 } }, [
                              _vm._v("外部小程序"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 7 } }, [
                              _vm._v("微信红包封面"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "推荐内容" } }, [
                      _vm.formData.recommendType != 1
                        ? _c(
                            "div",
                            { staticClass: "inline-items" },
                            [
                              _vm.formData.recommendType == 6
                                ? _c(
                                    "el-select",
                                    {
                                      staticClass: "inline-select",
                                      attrs: {
                                        placeholder: "请选择小程序类型",
                                        clearable: "",
                                      },
                                      on: {
                                        change: _vm.changeRecommendContentSub,
                                      },
                                      model: {
                                        value: _vm.formData.recommendContentSub,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContentSub",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.recommendContentSub",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "社区",
                                          value: "GAGAS",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "其他",
                                          value: "other",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.formData.recommendContentSub == "GAGAS" &&
                                _vm.formData.recommendType == 6) ||
                              _vm.formData.recommendType == 3 ||
                              _vm.formData.recommendType == 4 ||
                              _vm.formData.recommendType == 8
                                ? _c(
                                    "el-select",
                                    {
                                      staticClass: "inline-select",
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择页面",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.formData.recommendContentId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContentId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.recommendContentId",
                                      },
                                    },
                                    _vm._l(_vm.pageList, function (opt) {
                                      return _c("el-option", {
                                        key: opt.id,
                                        attrs: {
                                          label: opt.label,
                                          value: opt.id,
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formData.recommendType == 2 ||
                              (_vm.formData.recommendType == 6 &&
                                _vm.formData.recommendContentSub == "other")
                                ? _c("el-input", {
                                    staticClass: "inline-input",
                                    attrs: {
                                      placeholder: "请输入",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.recommendContent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "recommendContent",
                                          $$v
                                        )
                                      },
                                      expression: "formData.recommendContent",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formData.recommendType == 5 ||
                              _vm.formData.recommendType == 7 ||
                              (_vm.formData.recommendType == 6 &&
                                _vm.formData.recommendContentSub == "other")
                                ? _c("el-input", {
                                    staticClass: "inline-input",
                                    attrs: {
                                      placeholder: "请输入URL",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.recommendContentId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "recommendContentId",
                                          $$v
                                        )
                                      },
                                      expression: "formData.recommendContentId",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formData.recommendType == 3 ||
                              _vm.formData.recommendType == 5 ||
                              _vm.formData.recommendType == 6 ||
                              _vm.formData.recommendType == 8
                                ? _c("el-input", {
                                    staticClass: "inline-input",
                                    attrs: {
                                      placeholder:
                                        "请输入参数，如：id=122&name=test",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.recommendContentParam,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "recommendContentParam",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.recommendContentParam",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "recommend-type-hint" },
                                [
                                  _vm.formData.recommendType == 2
                                    ? _c("span", { staticClass: "hint-text" }, [
                                        _vm._v(
                                          "请填写优惠券发放活动ID（活动类型需为领取，只填写id）"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formData.recommendType == 3 ||
                                  _vm.formData.recommendType == 4 ||
                                  _vm.formData.recommendType == 8
                                    ? _c("span", { staticClass: "hint-text" }, [
                                        _vm._v(
                                          "请选择跳转页面及输入参数，参数格式如：id=122&name=test"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formData.recommendType == 5
                                    ? _c("span", { staticClass: "hint-text" }, [
                                        _vm._v(
                                          "请填写跳转页面地址及参数，参数格式如：id=122&name=test"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formData.recommendType == 6
                                    ? _c("span", { staticClass: "hint-text" }, [
                                        _vm._v(
                                          "请填写外部小程序appid、跳转地址及参数，参数格式如：id=122&name=test"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formData.recommendType == 7
                                    ? _c("span", { staticClass: "hint-text" }, [
                                        _vm._v("请填写微信红包封面地址URL"),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否永久有效", required: "" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.formData.isPermanent,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isPermanent", $$v)
                              },
                              expression: "formData.isPermanent",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.formData.isPermanent
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "时间范围", required: "" } },
                          [
                            _c(
                              "div",
                              { staticClass: "time-picker-group" },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetime",
                                    placeholder: "开始时间",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                  },
                                  model: {
                                    value: _vm.formData.startTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "startTime", $$v)
                                    },
                                    expression: "formData.startTime",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "time-separator" }, [
                                  _vm._v("-"),
                                ]),
                                _vm._v(" "),
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetime",
                                    placeholder: "结束时间",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                  },
                                  model: {
                                    value: _vm.formData.endTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "endTime", $$v)
                                    },
                                    expression: "formData.endTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "排序", prop: "sort" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            max: 9999,
                            "controls-position": "right",
                          },
                          model: {
                            value: _vm.formData.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "sort", $$v)
                            },
                            expression: "formData.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "图片" } }, [
                      _c("div", { staticClass: "image-upload-container" }, [
                        _c("input", {
                          ref: "fileInput",
                          staticStyle: { display: "none" },
                          attrs: { type: "file", accept: "image/*" },
                          on: { change: _vm.handleFileChange },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-area" }, [
                          _c(
                            "div",
                            {
                              staticClass: "image-preview",
                              on: { click: _vm.handleImageClick },
                            },
                            [
                              _vm.formData.imageUrl
                                ? _c("img", {
                                    staticClass: "preview-img",
                                    attrs: {
                                      src: _vm.getImageUrl(
                                        _vm.formData.imageUrl
                                      ),
                                      alt: "资源位图片",
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "image-placeholder" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否显示", prop: "visible" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.formData.visible,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "visible", $$v)
                            },
                            expression: "formData.visible",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览二维码",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览二维码" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "二维码预览",
            visible: _vm.qrCodeDialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrCodeDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "qr-code-container" }, [
            _vm.qrCodeImage
              ? _c("img", {
                  staticClass: "qr-code-image",
                  attrs: { src: _vm.qrCodeImage, alt: "二维码" },
                })
              : _c("div", { staticClass: "qr-code-placeholder" }, [
                  _c("i", { staticClass: "el-icon-loading" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("二维码生成中...")]),
                ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.qrCodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }